import { faFolder } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IPictureFileMetadataResponse } from '@kcftech/prometheustypescriptapiclient';
import { ArrowLink } from 'components/link/ArrowLink';
import { CellNameText, FolderIconWrapper } from 'pages/Settings/FileLibrary/styled';

export type FolderNameCellProps = Readonly<{
    folderData: IPictureFileMetadataResponse;
    onFolderClick: (folderData: IPictureFileMetadataResponse) => void;
}>;

export function FolderNameCell({ folderData, onFolderClick }: FolderNameCellProps) {
    return (
        <>
            <FolderIconWrapper>
                <FontAwesomeIcon
                    icon={faFolder}
                    color="var(--warning-default)"
                    size="3x"
                />
            </FolderIconWrapper>
            <ArrowLink
                to="#"
                onClick={(e) => {
                    e.preventDefault();
                    onFolderClick(folderData);
                }}
                iconColor="var(--icon-action-active)"
            >
                <CellNameText className="ellipsis-1-line" title={folderData.DisplayName}>
                    {folderData.DisplayName}
                </CellNameText>
            </ArrowLink>
        </>
    );
}
